import { getApiUrlPath } from '@/models/constant'
import { GenericService } from '@/models/shared'
import { IPolicyConditionResponse } from './response'
import { IPolicyConditionRequest } from './request'


export class PolicyConditionFactory extends GenericService<IPolicyConditionRequest,
  IPolicyConditionResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath('PolicyCondition')
    })
  }
}

